import { FunctionComponent, h } from 'preact';
import { Desktop } from '../../responsive-devices/responsive-devices';
import TrackingMap from './tracking-map/tracking-map';
import TrackingPanel from './tracking-panel/tracking-panel';

const Tracking: FunctionComponent = () => {
	return (
		<div className="tracking" data-testid="tracking">
			<TrackingPanel />
			<Desktop>
				<TrackingMap />
			</Desktop>
		</div>
	);
};

export default Tracking;
